import {
  aboutParams,
  AboutSoftware,
  Customer,
  RespAboutInterface,
  RespAboutModel,
} from "./About.model";
import { apiService } from "../../../../services/apiService";
import { apiServiceConstants } from "../../../../constants";
import { utilService } from "../../../../services/utilService";

const getAboutDetails = async (
  params: aboutParams
): Promise<RespAboutInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `user/about/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const aboutResp = res as RespAboutModel;
      const aboutResponse = setAboutModel(aboutResp);
      const result: RespAboutInterface = {
        isSuccess: aboutResp.isSuccess,
        displayAboutContainer: aboutResponse,
        status: aboutResp.status,
        message: aboutResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: RespAboutInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        displayAboutContainer: [],
      };
      return result;
    });

  return respApiResult;
};

const setAboutModel = (payload: RespAboutModel): any => {
  let AboutListArray = payload.result?.map((object: any) => {
    return {
      aboutSoftware: mapAboutSoftware(object.about_software),
      customer: mapCustomer(object.customer),
      aboutCompany: object.about_company,
    };
  });
  return AboutListArray;
};

const mapAboutSoftware = (softwareData: AboutSoftware) => {
  var groupObject = {
    customerAppVersion: softwareData.custome_app_version,
    releaseYear: softwareData.release_year,
  };
  return groupObject;
};

const mapCustomer = (customerData: Customer) => {
  var groupObject = {
    mail: customerData.mail,
    phone: customerData.phone,
    website: customerData.website,
    playstore: customerData.playstore,
    appstore: customerData.appstore,
  };
  return groupObject;
};

const handleErrorResponse = () => {};

export const AboutService = {
  getAboutDetails,
  handleErrorResponse,
};
